<template>
    <div class="vx-card p-6 ">
        <h2 class="header-title">{{ projectDetails.title }}</h2>
        <vs-tabs>
            <vs-tab label="Tổng Quan">
                <ProjectOverview :projectDetails="projectDetails"></ProjectOverview>
            </vs-tab>
            <vs-tab label="Kanban">
                <Tasks></Tasks>
            </vs-tab>
            <vs-tab label="Thành viên">
                <UserProject></UserProject>
            </vs-tab>
            <vs-tab label="Files">
                <TaskFiles></TaskFiles>
            </vs-tab>
<!--            <vs-tab label="Reports">-->
<!--                <div class="con-tab-ejemplo">-->
<!--                    login-->
<!--                </div>-->
<!--            </vs-tab>-->
        </vs-tabs>
    </div>
</template>

<script>
import ProjectOverview from "./ProjectOverview";
import Tasks from './Tasks.vue';
import UserProject from './UserProject.vue'
import TaskFiles from './TaskFiles.vue'
import moment from "moment";

export default {
    components: {
        ProjectOverview,
        Tasks,
        UserProject,
        TaskFiles,
    },

    data() {
        return {
            projectDetails: [],
        }
    },

    created() {
        let projectId = parseInt(this.$route.query.id, 10);
        this.getProjectDetail(projectId)
    },

    methods: {
        getProjectDetail(projectId) {
            this.$vs.loading(projectId);
            this.$crm.get(`/project/find-by-id/${projectId}`).then((response) => {
                this.$vs.loading.close();
                if (response.data) {
                    this.projectDetails = response.data
                    this.projectDetails.startTimeCvt = moment(this.projectDetails.startTime).format('DD/MM/YYYY');
                    this.projectDetails.endTimeCvt = moment(this.projectDetails.endTime).format('DD/MM/YYYY');
                }
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
            })
        },
    }
}

</script>

<style scoped>

</style>
